import _ from 'lodash';
import OPERATORS from '../constants/operators';

const operatorMap = {
  [OPERATORS.STARTS_WITH]: (value, str) => _.startsWith(value, str),
  [OPERATORS.CONTAINS]: (value, str) => _.includes(value, str),
};
const textFilterMethod = (filter, row) => {
  const {
    operator,
    string,
    clearFilter,
    multiSelectValues,
  } = filter.value;
  const rowValue = row[filter.id];
  if (clearFilter) {
    return true;
  }

  if (multiSelectValues && multiSelectValues.length) {
    return !!_.find(multiSelectValues, { value: rowValue || null });
  }

  return !operatorMap[operator] || operatorMap[operator](
    rowValue && rowValue.toLowerCase(),
    string.toLowerCase(),
  );
};

export default textFilterMethod;
